import React from "react";
import PropTypes from "prop-types";

Close.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    opacity: PropTypes.number
};

Close.defaultProps = {
    className: "",
    color: "white",
    opacity: 1
};

export default function Close({color, className, opacity}) {
    return (
        <svg className={className} width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path
                d="M33 1L1 33M1 1l32 32"
                stroke={color}
                strokeWidth="2"
                opacity={opacity}
            />
        </svg>
    );
}
